import { render, staticRenderFns } from "./userMgtDetails.vue?vue&type=template&id=cc86ffaa&scoped=true&"
import script from "./userMgtDetails.vue?vue&type=script&lang=js&"
export * from "./userMgtDetails.vue?vue&type=script&lang=js&"
import style0 from "./userMgtDetails.vue?vue&type=style&index=0&id=cc86ffaa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc86ffaa",
  null
  
)

export default component.exports